const PROJECT_ID = 'marpple';

const LAN_KOREAN = 'ko';
const LAN_ENGLISH = 'en';
const LAN_JAPANESE = 'ja';

export { PROJECT_ID, LAN_KOREAN, LAN_ENGLISH, LAN_JAPANESE };
